import './App.css';
import { useState, useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import Navbar from './component/Home/Navbar';
import Footer from './component/Home/Footer';
import product from './component/Home/ProductApi';
import Card from './component/Home/Card';
import About from './component/Pages/About';
import Contact from './component/Pages/Contact';
import Developer from './component/Pages/Develeoper';
import Faq from './component/Pages/Faq';
import Policy from './component/Legal/Policy';
import Terms from './component/Legal/Terms';
import Licence from './component/Legal/Licence';
import UserProfilePage from './component/User/UserProfile';
import SocialMedia from './component/Pages/SocialMedia';
import BookMark from './component/Explore/BookMark';
import ErrorPage from './component/Pages/ErrorPage';
import ISO from './component/Explore/ISOFiles/ISOFiles';
import Gallery from './component/Explore/LinkLibrary/Gallery';
import galleryArray from './component/Explore/LinkLibrary/GalleryApi';
import Login from './component/User/Login';

function App() {
  const uniqueList = useMemo(() => [
    ...new Set(product.map((curElem) => curElem.category)),
    "All Products"
  ], []);
  
  const [productData, setProductData] = useState(product);
  
  const filterItem = (category) => {
    if(category === "All Products"){
      setProductData(product);
      return;
    }
    const updatedList = product.filter((curElem) => curElem.category === category);
    setProductData(updatedList);
  };
  
  return (
    <>

      <Navbar filterItem={filterItem} menuList={uniqueList} />
      <Routes>
        <Route exact path="/" element={<Card productData={productData} />} />

        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/developer" element={<Developer />} />
     
        <Route path="/user-profile" element={<UserProfilePage />} />
        <Route path="/social-media" element={<SocialMedia />} />
        <Route path="/bookmark" element={<BookMark />} /> 

        <Route path="/legal/privacy" element={<Policy />} />
        <Route path="/legal/terms" element={<Terms />} />
        <Route path="/legal/licence" element={<Licence />} />
        <Route path="/iso-files" element={<ISO   />} />
        <Route path="/LinkLibrary" element={<Gallery galleryArray={galleryArray}  />} />
        <Route path="*" element={ <ErrorPage/>} />
        <Route path="/login" element={ <Login/>} />
       
      </Routes>
     
      <Footer />

    </>
  );
}

export default App;
